@import "@digipost/dds-core/less/dds.less";
@import "@digipost/dds-webfonts/fonts.less";
@import "@digipost/dds-buttons-react/dist/index.css";
@import "@digipost/dds-spinner-react/dist/index.css";
@import "@digipost/dds-input-react/dist/index.css";
@import "@digipost/dds-heading-react/dist/index.css";
@import "@digipost/dds-checkbox-react/dist/index.css";
@import "@digipost/dds-banner-react/dist/index.css";
@import "./variables.less";
@fonts-url: "@digipost/dds-webfonts/fonts";

@import "base.less";
@import "utils.less";
